const partnersFields = ['name', 'homeLink', 'shortName', 'classLogo', 'logo'];

const sessionFields = [
  'active',
  'courseId',
  'dbEndDate',
  'durationString',
  'eligibleForCertificate',
  'hasSigTrack',
  'certificatesReleased',
  'homeLink',
  'instructorIds',
  'startDay',
  'startMonth',
  'startYear',
  'status',
  'v1VcDetailId',
];

const instructorFields = ['prefixName', 'firstName', 'middleName', 'lastName', 'suffixName', 'photo', 'title'];

const exported = {
  fields: ['role', 'courseId', 'enrolledTimestamp', 'lastAccessedTimestamp', 'grade', 'v1SessionId'],

  includes: {
    vcMembership: {
      fields: ['certificateCode', 'grade', 'grantedAt'],
    },
    signatureTrackProfile: {
      fields: ['firstName', 'middleName', 'lastName'],
    },
    course: {
      fields: [
        'name',
        'startDate',
        'durationString',
        'partnerLogo',
        'certificatePartnerLogo',
        'certificates',
        'photoUrl',
        'description',
        'workload',
      ],
      includes: {
        categories: {},
        partners: {
          fields: partnersFields,
        },
        instructors: {
          fields: instructorFields,
        },
        details: {
          fields: ['name', 'shortName', 'sessionIds', 'aboutTheCourse'],
          includes: {
            sessions: {
              fields: sessionFields,
            },
          },
        },
      },
    },
  },
};

export default exported;

export const { fields, includes } = exported;
